export default "__VITE_ASSET__6db7e1f5__"